import React from "react";

type DifyRunActionBarProps = {
  isSubmitting: boolean;
  hasRuns: boolean;
  canCancel: boolean;
  onCancel: () => void;
  onClear: () => void;
};

/**
 * 実行操作ボタンを表示する
 * @return 画面要素
 */
const DifyRunActionBar: React.FC<DifyRunActionBarProps> = ({
  isSubmitting,
  hasRuns,
  canCancel,
  onCancel,
  onClear,
}) => {
  return (
    <div className="dify-input-action-bar">
      <button type="submit" className="button-1 dify-api-custom-button" disabled={isSubmitting}>
        {isSubmitting ? "送信中..." : "送信"}
      </button>
      <button
        type="button"
        className="button-1 dify-api-custom-button"
        onClick={onCancel}
        disabled={!canCancel}
      >
        実行停止
      </button>
      <button
        type="button"
        className="button-1 dify-api-custom-button"
        onClick={onClear}
        disabled={!hasRuns || isSubmitting}
      >
        履歴クリア
      </button>
    </div>
  );
};

export default DifyRunActionBar;
